import axios from 'axios';
import { showErrorNotification } from "actions/action-complete-notificator";

export const ACTION_LOG_IN_USER_PENDING = 'ACTION_GET_CURRENT_USER_PENDING';
export const ACTION_LOG_IN_USER_SUCCESS = 'ACTION_GET_CURRENT_USER_SUCCESS';
export const ACTION_LOG_IN_USER_ERROR = 'ACTION_GET_CURRENT_USER_ERROR';

function logInUserPending() {
    return {
        type: ACTION_LOG_IN_USER_PENDING
    }
}

function logInUserSuccess(currentUser) {
    return {
        type: ACTION_LOG_IN_USER_SUCCESS,
        currentUser: currentUser
    }
}

function logInUserError(error) {
    showErrorNotification(error.response);
    return {
        type: ACTION_LOG_IN_USER_ERROR,
        error: error
    }
}

function logInUserAction(data) {
    axios.defaults.baseURL = window.location.origin;
    axios.defaults.withCredentials = true;
    var url = '/api/User/LogIn';
    return dispatch => {
        dispatch(logInUserPending());
        axios.post(url, data, { withCredentials: true })
            .then(res => res.data)
            .then(res => {
                dispatch(logInUserSuccess(res));
            })
            .catch(error => {
                dispatch(logInUserError(error));
            })
    }
}

export default logInUserAction;
